import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ArrowButton from 'steps/ArrowButton3'
import IntersectionVisible from 'components/IntersectionVisible'
import LockedStep from 'steps/LockedStep'
import SkipButton from 'steps/SkipButton'
import StartSlideWrapper from 'steps/StartSlideWrapper'
import { StepService } from 'services/common'
import { userContext } from 'global/context/sub-contexts/userContext'
import BreakHTMLFooter from './BreakHTMLFooter'
import { StepBackground } from './StepBackground'

// steps
// import ChecklistStep from "steps/checklist/ChecklistStep3"
import ChecklistStep from './checklist/ChecklistStep3'
import CompleteStep from 'steps/complete/CompleteStep3'
import CustomHtmlStep from 'steps/custom-html/CustomHtmlStep'
import CustomJSONStep from 'steps/custom-json/CustomJSONStep3'
import FilteringStep from 'steps/filtering/FilteringStep3'
import GalleryStep from 'steps/gallery/GalleryStep'
import GroceryStep from 'steps/grocery/GroceryStep'
import ListicleStep from 'steps/listicle/ListicleStep3'
import PersonalityQuizStep from 'steps/personality-quiz/PersonalityQuizStep3'
import PinterestStep from 'steps/pinterest/PinterestStep3'
import ReferralStep from 'steps/referral/ReferralStep3'
import TextTrivia from 'steps/text-trivia/TextTriviaStep3'
import UGCPhotoUpload from 'steps/ugc-photo-upload/UGCPhotoUploadStep'
import UGCVideoUpload from 'steps/ugc-video-upload/UGCVideoUploadStep'
import VideoStep from 'steps/video/VideoStep3'
import PollStep from 'steps/poll/PollStep3'
import PuzzleStep from 'steps/puzzle/PuzzleStep'
import LeadGenStep from 'steps/lead-gen/LeadGenStep3'
import ReceiptVerificationStep from 'steps/receipt/ReceiptVerificationStep'
import MemoryMatchStep from 'steps/memory-match/MemoryMatchStep'
import ReviewStep from 'steps/review/ReviewStep3'
import LocatorStep from 'steps/locator/LocatorStep3'

//This object associates the string assignments made in step.type with the actual .jsx components.
const stepComponents = {
  COMPLETE: CompleteStep,
  CHECKLIST: ChecklistStep,
  CUSTOM_HTML: CustomHtmlStep,
  CUSTOM_JSON: CustomJSONStep,
  FILTERING: FilteringStep,
  GALLERY: GalleryStep,
  GROCERY: GroceryStep,
  LISTICLE: ListicleStep,
  PERSONALITY_QUIZ: PersonalityQuizStep,
  PINTEREST: PinterestStep,
  REFERRAL: ReferralStep,
  TEXT_TRIVIA: TextTrivia,
  UGC_PHOTO: UGCPhotoUpload,
  MEDIA_UPLOAD: UGCVideoUpload,
  VIDEO: VideoStep,
  POLL: PollStep,
  PUZZLE: PuzzleStep,
  LEAD_GEN: LeadGenStep,
  RECEIPT_VERIFICATION: ReceiptVerificationStep,
  MEMORY_MATCH: MemoryMatchStep,
  REVIEW: ReviewStep,
  STORE_FINDER: LocatorStep,
}

//Associates step.type with the API url used to call the start/end services for a given step.
const stepServiceSlugs = {
  COMPLETE: 'complete',
  CHECKLIST: 'checklist',
  CUSTOM_HTML: 'customhtml', // TODO: hard-coded until we get a JSON step dance going in gatsby-node
  FILTERING: 'filter',
  GROCERY: 'grocery',
  LISTICLE: 'listicle',
  PERSONALITY_QUIZ: 'quiz',
  PINTEREST: 'pinterest',
  REFERRAL: 'referral',
  TEXT_TRIVIA: 'trivia',
  UGC_PHOTO: 'photoUpload',
  VIDEO: 'video',
  POLL: 'poll',
  PUZZLE: 'puzzle',
  LEAD_GEN: 'lead',
  RECEIPT_VERIFICATION: 'receiptVerification',
  MEMORY_MATCH: 'memory',
  REVIEW: 'review',
  STORE_FINDER: 'location',
  MEDIA_UPLOAD: 'videoUpload',
  CUSTOM_JSON: 'videoUpload',
  GALLERY: 'gallery',
}

const supportedStepType = stepType => {
  return stepComponents.hasOwnProperty(stepType)
}

const COMPLETE_BY_SKIP = true
const COMPLETE_NOT_SKIPPED = false

class Step3 extends Component {
  constructor(props) {
    super(props)

    this.state = {
      skipLinkVisible: true,
      arrowButtonVisible: this.defaultArrowVisibility(), //see function comment
      serverWaiting: false,
      stepBackgroundImageId: undefined,
      stepBackgroundColor: undefined,
      instantWinPause: false,
    }

    this.stepComponent = () => {
      return stepComponents[this.props.step.type]
    }
    this.setPaused = function (paused) {
      this.setState(prevState => {
        prevState.instantWinPause = true
        return prevState
      })
    }
    this.service = new StepService(
      stepServiceSlugs[this.props.step.type],
      this.props.breakId,
      this.props.step.id,
    )

    this.stepStarted = false
    this.stepCompleted = false
    this.stepEngaged = false

    // Step methods require binding "this" for proper scoping
    this.handleAwardPoints = this.handleAwardPoints.bind(this)
    this.handleEngage = this.handleEngage.bind(this)
    this.handleIsOnScreen = this.handleIsOnScreen.bind(this)
    this.handleStartSlideClick = this.handleStartSlideClick.bind(this)
    this.handleServerWaiting = this.handleServerWaiting.bind(this)
    this.handleSkipClick = this.handleSkipClick.bind(this)
    this.handleArrowClick = this.handleArrowClick.bind(this)
    this.handleBackgroundChange = this.handleBackgroundChange.bind(this)
    // Note: "babel transpilation does not correctly handle this reference when using bind and async together."
    //       https://github.com/babel/babel/issues/6806
    // That means we can't use arrow syntax on those member methods ^^^ that we just used bind() on
    //
    // We have to use:
    // async handleStartSlideClick() {
    //
    // Not:
    // handleStartSlideClick = async () => {

    //console.log(this.props)
  }

  // this is here for debugging
  // watch out: gatsby hot-module-reloading passes `cacheBusterProp` to force a re-render
  shouldComponentUpdate(nextProps, nextState) {
    // https://stackoverflow.com/questions/41004631/trace-why-a-react-component-is-re-rendering
    Object.entries(this.props).forEach(
      ([key, val]) =>
        nextProps[key] !== val && console.log(`Step3 prop '${key}' changed`),
    )

    Object.entries(this.state).forEach(
      ([key, val]) =>
        nextState[key] !== val && console.log(`Step3 state '${key}' changed`),
    )

    return true
  }
  defaultArrowVisibility() {
    //God this is hacky but here's the deal.
    //only custom html step has a default enabled next button;
    //otherwise it shouldn't appear on mount at all.
    return this.props.step.type === 'CUSTOM_HTML' ? true : false
  }
  async handleBackgroundChange({ backgroundImageId, backgroundColor }) {
    // console.log(`changing bg image! ${backgroundImageId}, ${backgroundColor}`)
    if (backgroundImageId) {
      this.setState({ stepBackgroundImageId: backgroundImageId })
    }
    if (backgroundColor && backgroundColor !== this.state.stepBackgroundColor) {
      this.setState({ stepBackgroundColor: backgroundColor })
    }
    //This returns bg to step default. This is probably the wrong way to do it.
    // if (backgroundColor === null) {
    //     this.state.backgroundColor = defaultStepBackgroundColor()
    //   }

    //    if (backgroundImageId === null) {
    //      this.state.stepBackgroundImageSrc = this.defaultBackgroundImageSrc()
    //  }
  }

  async handleIsOnScreen(isIntersecting) {
    //console.log("handleIsOnScreen", isIntersecting)

    if (isIntersecting) {
      if (!this.props.step.hasStartScreen && !this.stepStarted) {
        this.stepStarted = true
        try {
          const response = await this.service.start()
          if (response.status === 200) {
            const { attempt, firstBreakEngagement } = await response.json()
            this.props.onStepStart &&
              this.props.onStepStart(
                this.props.step,
                attempt,
                firstBreakEngagement,
              )
          }
        } catch (e) {
          console.warn(`handleIsOnScreen`, e)
        }
      }
    }

    // not on screen
    if (!isIntersecting) {
      // user moved on without clicking arrow
      if (this.stepStarted && !this.stepCompleted) {
        this.stepCompleted = true

        if (this.stepEngaged) {
          try {
            // some steps haven't been migrated to use /awardPoints endpoint
            // they'll award points on complete
            const response = await this.service.complete(COMPLETE_NOT_SKIPPED)
            const body = await response.json()
            if (body.totalPoints) {
              this.context.setPoints(body.totalPoints)
            }
          } catch (e) {
            console.log(`handleIsOnScreen awardPoints`, e)
          }
        } else {
          try {
            await this.service.complete(COMPLETE_BY_SKIP)
          } catch (e) {
            console.log(`handleIsOnScreen complete`, e)
          }
        }
      }
    }

    return isIntersecting
  }
  //To do: handler for intra-step general waiting-for-data situation. This means we can pop off a loading spinner centrally.
  async handleServerWaiting(isWaiting) {
    this.state.serverWaiting = isWaiting
  }

  async handleStartSlideClick() {
    console.log('handleStartSlideClick')

    // BR-1469
    // before we actually start, run this up the flag pole to make sure we're ok to start (user is logged in)
    const okToStart = await this.props.onAttemptStepStart(this.props.step.id)
    console.log(`okToStart: `, okToStart)

    if (!okToStart) {
      // parent said naw. We assume it performs some UI to resolve this situation (like pop a login modal)
      return false
    }

    if (!this.stepStarted) {
      this.stepStarted = true
      try {
        const response = await this.service.start()
        if (response.status === 200) {
          const { attempt, firstBreakEngagement } = await response.json()
          this.props.onStepStart &&
            this.props.onStepStart(
              this.props.step,
              attempt,
              firstBreakEngagement,
            )
        }
      } catch (e) {
        console.warn(`handleStartSlideClick`, e)
      }
    }

    // this allows the start slide wrapper to move on
    return true
  }

  async handleArrowClick(instantwinWrapper) {
    // console.log(`handleArrowClick`, this)

    if (this.stepCompleted === false) {
      try {
        // some steps haven't been migrated to use /awardPoints endpoint
        // they'll award points on complete
        const response = await this.service.complete(COMPLETE_NOT_SKIPPED)
        const body = await response.json()
        // console.log(body)
        if (body.totalPoints) {
          this.context.setPoints(body.totalPoints)
        }
      } catch (e) {
        console.log(`handleArrowClick`, e)
      }
    }

    this.stepCompleted = true

    this.props.onStepComplete && this.props.onStepComplete(this.props.step.id)
    this.props.onGoToNext && this.props.onGoToNext(this.props.step.id)
  }

  async handleSkipClick() {
    console.log('skip click', this)

    if (this.stepCompleted === false) {
      try {
        await this.service.complete(COMPLETE_BY_SKIP)
        // do we care about the response?
      } catch (e) {
        console.warn(e)
      }
    }

    this.props.onStepSkip(this.props.step.id)
    this.stepCompleted = true

    this.setState({
      skipLinkVisible: false,
      arrowButtonVisible: false,
    })
  }

  // step told us the user engaged
  // remove the skip link and enable the next button
  async handleEngage() {
    this.stepEngaged = true
    this.setState({
      skipLinkVisible: false,
      arrowButtonVisible: true,
    })
  }

  async handleAwardPoints(optionalPoints = 0) {
    // It's possible for a steps to fire handleAwardPoints() before Step3 has a chance to start them.
    // the API requires a step to be started in order to award points, so we check here
    if (!this.stepStarted) {
      this.stepStarted = true
      try {
        const response = await this.service.start()
        if (response.status === 200) {
          const { attempt, firstBreakEngagement } = await response.json()
          this.props.onStepStart &&
            this.props.onStepStart(
              this.props.step,
              attempt,
              firstBreakEngagement,
            )
        }
      } catch (e) {
        console.warn(`handleAwardPoints`, e)
      }
    }

    try {
      const response = await this.service.awardPoints(optionalPoints)
      if (response.status === 200) {
        const body = await response.json()
        const { totalPoints } = body
        this.context.setPoints(totalPoints) // TODO: call setPoints here or bubble it up?
      }
    } catch (e) {
      console.log(`handleAwardPoints`, e)
    }
  }
  //This is a lil sloppy, should clean up when i think of a better way.
  RenderHtmlFooter = () => (
    <BreakHTMLFooter content={this.props.brk.footerHtml} />
  )
  SkipButtonComponent = () =>
    this.props.step.showSkipButton && (
      <SkipButton
        onClick={this.handleSkipClick}
        isDisabled={!this.state.skipLinkVisible}
      />
    )
  RenderNextStepButton = () => (
    <ArrowButton
      isLastStep={
        JSON.stringify(
          this.props.brk.steps[this.props.brk.steps.length - 1],
        ) === JSON.stringify(this.props.step)
      }
      onClick={this.handleArrowClick}
      visible={this.state.arrowButtonVisible}
      clickable={true}
    />
  ) //Step 3 now does not feature a 'disabled' state
  GetThemeColors = () => {
    try {
      return {
        primaryCopyColor: this.props.brk.themeColor2,
        primaryColorButtons: this.props.brk.themeColor3,
      }
    } catch (e) {
      console.log(`GetThemeColors`, e)
    }
  }
  render() {
    const StepTag = this.stepComponent()

    // we all hate this, but it's the only way to get style data from beaker to be applied to desktop-only
    const inlineStyle = `
            .sponsored-flow-panel-${this.props.step.id} {
                background-color: ${this.props.step.backgroundColor};
            }

            @media (min-width: 900px) {
                .sponsored-flow-panel-${this.props.step.id} {
                ${
                  this.props.step.backgroundImage
                    ? `background: url(${process.env.SITE_ASSET_URL}/${this.props.step.backgroundImage.id});`
                    : ``
                }
                background-size: cover;
                }
            }
        `

    return (
      <>
        {this.props.isLocked ? (
          <section className="sponsored-flow-panel">
            <LockedStep
              backgroundImageId={
                this.props.step.startBackgroundImageId ||
                (this.props.step.backgroundImage &&
                  this.props.step.backgroundImage.id)
              }
              backgroundColor={this.props.step.startBackgroundColor}
              HtmlFooter={this.RenderHtmlFooter}
            />
          </section>
        ) : (
          <>
            <style
              dangerouslySetInnerHTML={{
                __html: inlineStyle,
              }}
            />

            <div
              className={`sponsored-flow-panel step-3-flow-panel ${
                this.state.serverWaiting ? 'server-waiting' : ''
              } ${
                this.state.arrowButtonVisible
                  ? `engagement-complete`
                  : `engagement-incomplete`
              } sponsored-flow-panel-${this.props.step.id}`}
            >
              <StepBackground
                stepBackgroundImageId={this.state.stepBackgroundImageId}
                stepBackgroundColor={this.state.stepBackgroundColor}
              />
              <IntersectionVisible onIntersect={this.handleIsOnScreen}>
                <StartSlideWrapper
                  startScreenDisabled={this.props.startScreenDisabled}
                  step={this.props.step}
                  handleStartSlideClick={this.handleStartSlideClick}
                  breakFooterHTML={this.props.brk.footerHtml}
                  isIntersecting={this.handleIsOnScreen()}
                >
                  <StepTag
                    brk={this.props.brk}
                    stepType={this.stepComponent()}
                    step={this.props.step}
                    breakId={this.props.breakId || this.props.brk.id}
                    stepId={this.props.step.id}
                    isEmbed={this.props.isEmbed} // complete step has different behavior for dailybreak vs embed
                    // isStarted={this.props.isStarted}
                    // isComplete={this.props.isComplete}
                    // isEditorial={this.props.isEditorial}
                    // onGoToNext={this.props.onGoToNext}
                    // onStepStart={this.props.onStepStart}
                    // onStepComplete={this.props.onStepComplete}
                    // unlockNextStep={this.props.unlockNextStep}
                    onStepSkip={this.props.onStepSkip}
                    themeColors={this.GetThemeColors()}
                    // terms={this.props.brk.customAbbreviatedTerms}
                    // relatedBreaks={this.props.relatedBreaks}
                    // scrollComplete={this.props.scrollComplete}
                    onEngage={this.handleEngage}
                    onAwardPoints={this.handleAwardPoints}
                    onServerWaiting={this.handleServerWaiting}
                    onChangeBackground={this.handleBackgroundChange}
                    nextStepButton={this.RenderNextStepButton()}
                    skipButton={this.SkipButtonComponent()}
                    handleInstantWinEvent={this.props.handleInstantWinEvent}
                  />

                  <div className="sponsored-flow-panel--footer sponsored-flow-panel-3--footer">
                    <BreakHTMLFooter content={this.props.brk.footerHtml} />
                  </div>
                </StartSlideWrapper>
              </IntersectionVisible>
            </div>
          </>
        )}
      </>
    )
  }
}

Step3.contextType = userContext

Step3.propTypes = {
  step: PropTypes.object, // consider converting this param to JSON string so react can compare it / minimize renders
  breakId: PropTypes.string,
  stepId: PropTypes.string,
  isStarted: PropTypes.bool,
  isComplete: PropTypes.bool,
  terms: PropTypes.string, //oh god this is bad
  onGoToNext: PropTypes.func,
  onStepStart: PropTypes.func,
  onStepComplete: PropTypes.func,
  themeColors: PropTypes.object,
  onStepSkip: PropTypes.func,
  onAttemptStepStart: PropTypes.func,

  // scrollComplete: PropTypes.bool,
}

export { Step3, supportedStepType }
